import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DcpSearchProductModule} from './dcp-search-product/dcp-search-product.module';
import {DcpSearchProductGridModule} from './dcp-search-product-grid/dcp-search-product-grid.module';
import {SearchResultPageModule} from './results/search-result-page.module';

@NgModule({
  imports: [
    CommonModule,
    DcpSearchProductModule,
    DcpSearchProductGridModule,
    SearchResultPageModule,
  ],
  exports: [
    DcpSearchProductModule,
    DcpSearchProductGridModule,
    SearchResultPageModule
  ]
})
export class SearchModule {
}
